import React, { Component } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { Input, RadioButton, Select, Button } from 'loyal-react'
import { genderTypes, maritalStatuses, profileStatuses } from '..'
import { buildPhone, getOnlyNumbers } from 'Participant/ducks'
import { validate as validateCPF } from 'gerador-validador-cpf'

class Individual extends Component {
  state = {
    dirty: false,
    isValid: true,
    name: this.props.participant.name,
    cpf: this.props.participant.cpf,
    email: this.props.participant.email,
    homePhone: {
      value: `${this.props.participant.phones.home &&
        this.props.participant.phones.home.areaCode}${this.props.participant
        .phones.home && this.props.participant.phones.home.number}`,
      disabled:
        this.props.participant.phones.home &&
        this.props.participant.phones.home.disabled
    },
    mobilePhone: {
      value: `${this.props.participant.phones.mobile &&
        this.props.participant.phones.mobile.areaCode}${this.props.participant
        .phones.mobile && this.props.participant.phones.mobile.number}`,
      disabled:
        this.props.participant.phones.mobile &&
        this.props.participant.phones.mobile.disabled
    },
    genderType: {
      value:
        this.props.participant.genderType &&
        genderTypes[this.props.participant.genderType.value]
    },
    birthDate: this.props.participant.birthDate,
    maritalStatusSelected: {
      value:
        this.props.participant.maritalStatus &&
        maritalStatuses.getById(this.props.participant.maritalStatus.value)
          .value,
      text: this.props.participant.maritalStatus &&
      maritalStatuses.getById(this.props.participant.maritalStatus.value)
        .text,
      disabled:
        this.props.participant.maritalStatus &&
        this.props.participant.maritalStatus.disabled
    }
  }

  isValid = () => {
    let isValid = true
    const mailValidator = /^[a-zA-Z0-9.!#$%&'+/=?^_`{|}~-]+@([a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+)$/gim
    const { name, cpf, email, mobilePhone, birthDate } = this.state

    const nameValidator = /^[\wÀ-Ÿ\-&\s()]+(?![http:https:])$/

    if (!nameValidator.test(name.value)) {
      this.setState({
        name: {
          value: name.value,
          disabled: name.disabled,
          error: 'Digite um nome válido'
        }
      })
      isValid = false
    }

    if (!name.value) {
      this.setState({
        name: {
          value: name.value,
          disabled: name.disabled,
          error: 'Digite seu nome'
        }
      })
      isValid = false
    }

    if (!validateCPF(cpf.value)) {
      this.setState({
        cpf: {
          value: cpf.value,
          disabled: cpf.disabled,
          error: 'Digite um CPF válido'
        }
      })
      isValid = false
    }

    if (!mailValidator.test(email.value)) {
      this.setState({
        email: {
          value: email.value,
          disabled: email.disabled,
          error: 'Digite um e-mail válido'
        }
      })
      isValid = false
    }

    if (!mobilePhone.value) {
      this.setState({
        mobilePhone: {
          value: mobilePhone.value,
          disabled: mobilePhone.disabled,
          error: 'Digite um celular válido'
        }
      })
      isValid = false
    }

    if (!birthDate.value) {
      this.setState({
        birthDate: {
          ...birthDate,
          value: birthDate.value,
          error: 'Digite sua data de nascimento'
        }
      })
      isValid = false
    }
    this.setState({ isValid })
  }

  buttonProps = () =>
    this.props.participant.updatedSuccessfully
      ? { text: 'Salvo', className: 'btn btn-sm btn-featured bg-success' }
      : { text: 'Salvar', className: 'btn btn-sm btn-featured' }

  handleOnSubmit = () => {
    if (!this.state.isValid) return

    const {
      name,
      cpf,
      email,
      homePhone,
      mobilePhone,
      birthDate,
      maritalStatusSelected,
      genderType
    } = this.state
    const { address } = this.props.participant

    let phones = []
    if (homePhone.value) phones.push(buildPhone(homePhone.value, 'HOME'))
    if (mobilePhone.value) phones.push(buildPhone(mobilePhone.value, 'MOBILE'))

    this.props.updateParticipant({
      name: name.value,
      documentNumber: getOnlyNumbers(cpf.value),
      maritalStatus: maritalStatusSelected.value,
      genderType: genderType.value,
      birthDate:
        birthDate.value && moment(birthDate.value, 'DD/MM/YYYY').format(),
      emails: [{ email: email.value, type: 'PERSONAL' }],
      status: profileStatuses[this.props.participant.statusId],
      profileId: this.props.participant.profileId,
      phones,
      address: address
        ? {
          street: address.addressText.value,
          number: address.number.value,
          complement: address.complement.value,
          district: address.district.value,
          city: address.city.value,
          state: address.state.value ? address.state.value : 'SP',
          zipCode: address.zipCode.value ? address.zipCode.value : '00000000'
        }
        : {
          street: '',
          number: '',
          complement: '',
          district: '',
          city: '',
          state: 'SP',
          zipCode: '00000000'
        }
    })
  }

  handleInputValid (input) {
    if (input && input.error) return false

    return null
  }

  handleInputChange = event => {
    this.setState({
      [event.target.name]: { value: event.target.value },
      dirty: true
    })
  }

  handleSelectInputChange = value => {
    this.setState({
      maritalStatusSelected: { value: value.id },
      dirty: true
    })
  }

  componentDidUpdate () {
    if (!this.props.participant.updatedSuccessfully) return

    setTimeout(() => {
      this.setState({ dirty: false })
      this.props.expireUpdatedParticipant()
    }, 3000)
  }

  render () {
    return (
      <div className='col-12 px-2 pt-2'>
        <div className='row mx-0'>
          <RadioButton
            id='genderType-male'
            name='genderType'
            label='Masculino'
            className='col-4 col-md-3 pb-1'
            tabIndex={0}
            labelClass='l-1'
            outerLabel={false}
            role='radio'
            value='MALE'
            onClick={this.handleInputChange}
            defaultChecked={this.state.genderType.value === 'MALE'}
          />
          <RadioButton
            id='genderType-female'
            name='genderType'
            label='Feminino'
            className='col-4 col-md-3 pb-1'
            tabIndex={0}
            labelClass='l-1'
            outerLabel={false}
            role='radio'
            value='FEMALE'
            onClick={this.handleInputChange}
            defaultChecked={this.state.genderType.value === 'FEMALE'}
          />
          <RadioButton
            id='genderType-uninformed'
            name='genderType'
            label='Outros'
            className='col-4 col-md-3 pb-1'
            tabIndex={0}
            labelClass='l-1'
            outerLabel={false}
            role='radio'
            value='UNINFORMED'
            onClick={this.handleInputChange}
            defaultChecked={this.state.genderType.value === 'UNINFORMED'}
          />
          <div className='col-12 clearfix' />
          <Input
            id='input-name-profile-data'
            label='Nome'
            className='col-12 col-md-6'
            tabIndex={0}
            minLength='1'
            maxLength='50'
            name='name'
            required
            data-error={this.state.name.error}
            valid={this.handleInputValid(this.state.name)}
            onChange={this.handleInputChange}
            value={this.state.name.value}
            disabled={this.state.name.disabled === 'true'}
            onBlur={this.isValid}
          />

          <Input
            id='input-cpf-profile-data'
            label='CPF'
            className='col-12 col-md-6 mt-md-0 mt-2'
            tabIndex={0}
            required
            mask={[
              /\d/,
              /\d/,
              /\d/,
              '.',
              /\d/,
              /\d/,
              /\d/,
              '.',
              /\d/,
              /\d/,
              /\d/,
              '-',
              /\d/,
              /\d/
            ]}
            name='cpf'
            data-error={this.state.cpf.error}
            valid={this.handleInputValid(this.state.cpf)}
            onChange={this.handleInputChange}
            value={this.state.cpf.value}
            disabled={this.state.cpf.disabled === 'true'}
            onBlur={this.isValid}
          />
          <Input
            id='birthDate'
            label='Data de nascimento'
            className='col-12 col-md-6 mt-2'
            tabIndex={0}
            name='birthDate'
            required
            mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
            onChange={this.handleInputChange}
            value={this.state.birthDate && this.state.birthDate.value}
            disabled={this.state.birthDate && this.state.birthDate.disabled === 'true'}
            onBlur={this.isValid}
            data-error={this.state.birthDate && this.state.birthDate.error}
            valid={this.handleInputValid(this.state.birthDate)}
          />
          <Input
            id='input-email-profile-data'
            label='E-mail'
            className='col-12 col-md-6 mt-2'
            tabIndex={0}
            required
            name='email'
            data-error={this.state.email.error}
            valid={this.handleInputValid(this.state.email)}
            onChange={this.handleInputChange}
            value={this.state.email.value}
            disabled='true'
            onBlur={this.isValid}
          />
          <Select
            id='maritalStatus'
            label='Estado civil'
            className='col-12 col-md-6 mt-2'
            tabIndex={0}
            displayValue='text'
            selectedValue='value'
            name='maritalStatusSelected'
            value={this.state.maritalStatusSelected}
            disabled={this.state.maritalStatusSelected && this.state.maritalStatusSelected.disabled === 'true'}
            options={maritalStatuses.options}
            onChange={this.handleSelectInputChange}
          />
          <Input
            id='input-mobilePhone-profile-data'
            label='Celular'
            className='col-12 col-md-6 mt-2'
            tabIndex={0}
            required
            mask={[
              '(',
              /[1-9]/,
              /\d/,
              ')',
              ' ',
              /\d/,
              /\d/,
              /\d/,
              /\d/,
              /\d/,
              '-',
              /\d/,
              /\d/,
              /\d/,
              /\d/
            ]}
            data-error={this.state.mobilePhone.error}
            valid={this.handleInputValid(this.state.mobilePhone)}
            onChange={this.handleInputChange}
            name='mobilePhone'
            value={this.state.mobilePhone.value}
            disabled={this.state.mobilePhone.disabled === 'true'}
            onBlur={this.isValid}
          />
          <Input
            id='input-phone-profile-data'
            label='Telefone Residencial'
            className='col-12 col-md-6 mt-2'
            tabIndex={0}
            guide={false}
            mask={
              this.state.homePhone.value.replace(/\D/g, '').length < 11
                ? [
                  '(',
                  /[1-9]/,
                  /\d/,
                  ')',
                  ' ',
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                  '-',
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/
                ]
                : [
                  '(',
                  /[1-9]/,
                  /\d/,
                  ')',
                  ' ',
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                  '-',
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/
                ]
            }
            name='homePhone'
            onChange={this.handleInputChange}
            value={this.state.homePhone.value}
            disabled={this.state.homePhone.disabled === 'true'}
            onBlur={this.isValid}
          />

          <div className='offset-md-6 col-12 col-md-6 mt-2'>
            <Button
              id='btn-save-participant'
              tabIndex={0}
              onClick={this.handleOnSubmit}
              disabled={!this.state.dirty || !this.state.isValid}
              {...this.buttonProps()}
              loading={this.props.participant.isUpdating}
            />
          </div>
        </div>
      </div>
    )
  }
}

const valueType = PropTypes.shape({
  value: PropTypes.string.isRequired,
  disabled: PropTypes.string.isRequired
})

const valueTypeNumber = PropTypes.shape({
  value: PropTypes.number.isRequired,
  disabled: PropTypes.string.isRequired
})

Individual.propTypes = {
  participant: PropTypes.shape({
    name: valueType,
    cpf: valueType,
    email: valueType,
    phones: PropTypes.object,
    genderType: PropTypes.object,
    birthDate: valueType,
    maritalStatus: valueTypeNumber,
    profileId: PropTypes.number.isRequired,
    statusId: PropTypes.number.isRequired,
    address: PropTypes.object.isRequired,
    isUpdating: PropTypes.bool.isRequired,
    updatedSuccessfully: PropTypes.bool
  }).isRequired,
  updateParticipant: PropTypes.func.isRequired,
  expireUpdatedParticipant: PropTypes.func.isRequired
}

export default Individual



// WEBPACK FOOTER //
// ./src/Participant/Profile/Individual.js